/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sound_Steep_Sheep_CryInputs */

const fr_sound_steep_sheep_cry = /** @type {(inputs: Sound_Steep_Sheep_CryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun programme affiché pour le moment`)
};

/**

* @param {Sound_Steep_Sheep_CryInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sound_steep_sheep_cry = /** @type {((inputs?: Sound_Steep_Sheep_CryInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sound_Steep_Sheep_CryInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sound_steep_sheep_cry(inputs)
});